import { Collapse, Form } from 'antd';
import LeftMenuDesign from '../../common/LeftMenuDesign/LeftMenuDesign';
import './LeftColumnCabinetCustomDesignMenu.scss';
import InputComponent from '../../common/InputComponent/InputComponent';
import { Icon } from '../../icon/icon';
import SelectComponent from '../../common/SelectComponent/SelectComponent';
import Slider from '../../common/Slider/Slider';
import ButtonIconGhostSmall from '../../common/ButtonIconGhost/ButtonIconGhostSmall';
import { useContext, useEffect, useState } from 'react';
import { CabinetEditorContext } from '../CabinetEditor/CabinetEditor';
import TabComponent from '../../common/TabComponent/TabComponent';
import { useTranslation } from 'react-i18next';
const { Panel } = Collapse;

const LeftColumnCabinetCustomDesignMenu = ({ open, form }) => {
  const { t } = useTranslation();
  const cabinetEditorContext = useContext(CabinetEditorContext);

  const [tab, setTab] = useState('1');

  const formForCurrentCabinet = {
    cabinet: (
      <Panel
        onKeyDown={e => {
          e.stopPropagation();
        }}
        header={<span className="text-title-medium">{t('Frame')}</span>}
        key="1"
      >
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item
            label={t('Height')}
            name={'height'}
            validateTrigger="onChange"
          >
            <InputComponent
              type="number"
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              defaultValue={
                cabinetEditorContext.mdCustomData.mdDimensions.height * 1000
              }
              onChange={e => {
                const height = parseFloat(e.target.value) || 0;
                handleScaleModule({
                  height: height / 1000, // Convert mm to m
                });
              }}
            />
          </Form.Item>
          <Form.Item
            label={t('Depth')}
            name={'depth'}
            validateTrigger="onChange"
          >
            <InputComponent
              type="number"
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              defaultValue={
                cabinetEditorContext.mdCustomData.mdDimensions.depth * 1000
              }
              onChange={e => {
                const depth = parseFloat(e.target.value) || 0;
                handleScaleModule({
                  depth: depth / 1000, // Convert mm to m
                });
              }}
            />
          </Form.Item>
          <Form.Item label={t('Board thickness')}>
            <InputComponent
              type="number"
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              defaultValue={
                cabinetEditorContext.mdCustomData.mdDimensions.thickness * 1000
              }
              onChange={e => {
                const thickness = parseFloat(e.target.value) || 0;
                handleScaleModule({
                  thickness: thickness / 1000, // Convert mm to m
                });
              }}
            />
          </Form.Item>

          {cabinetEditorContext.mdCustomData.mdOptions.optionCua && (
            <Form.Item label={t('Door type')}>
              <InputComponent
                type="number"
                // addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                defaultValue={
                  cabinetEditorContext.mdCustomData.mdOptions.optionCua
                }
                onChange={e => {
                  const optionCua = parseFloat(e.target.value) || 0;
                  handleScaleModule({
                    optionCua: optionCua,
                  });
                }}
              />
            </Form.Item>
          )}
        </div>
      </Panel>
    ),
    // tấm hậu
    backPlank: (
      <Panel
        onKeyDown={e => {
          e.stopPropagation();
        }}
        header={<span className="text-title-medium">{t('Back plank')}</span>}
        key="2"
      >
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item className="self-stretch">
            <SelectComponent
              options={[]}
              placeholder={t('Select back plank type')}
              style={{ flex: '1 0 0' }}
              size={'default'}
            />
          </Form.Item>
          <Form.Item label={t('Board thickness')}>
            <div className="flex items-center gap-4">
              <InputComponent
                type="number"
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
              <ButtonIconGhostSmall icon={<Icon.ICLockOpen />} />
            </div>
          </Form.Item>
          <Form.Item label={t('Retract back plank')} className="self-stretch">
            <div className="flex gap-8 items-center grow">
              <Slider style={{ flex: '1 0 0' }} />
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                type="number"
                placeholder={'--'}
                size={'small'}
                style={{ width: '84px' }}
              />
              <ButtonIconGhostSmall icon={<Icon.ICRestart />} />
            </div>
          </Form.Item>
        </div>
      </Panel>
    ),
    cabinetLegs: (
      <Panel
        onKeyDown={e => {
          e.stopPropagation();
        }}
        header={<span className="text-title-medium">{t('Cabinet legs')}</span>}
        key="3"
      >
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item className="self-stretch">
            <SelectComponent
              options={[]}
              placeholder={t('Select cabinet leg type')}
              style={{ flex: '1 0 0' }}
              size={'default'}
            />
          </Form.Item>

          <Form.Item label={t('Leg height')} className="self-stretch">
            <div className="flex items-center gap-4">
              <InputComponent
                type="number"
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
              <ButtonIconGhostSmall icon={<Icon.ICLockOpen />} />
            </div>
          </Form.Item>
          <Form.Item label={t('Retract legs')} className="self-stretch">
            <div className="flex gap-8 items-center grow">
              <Slider style={{ flex: '1 0 0' }} />
              <InputComponent
                type="number"
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                size={'small'}
                style={{ width: '84px' }}
              />
              <ButtonIconGhostSmall icon={<Icon.ICRestart />} />
            </div>
          </Form.Item>
        </div>
      </Panel>
    ),
  };

  const formColumn = {
    column: (
      <Panel
        header={<span className="text-title-medium">{t('Column')}</span>}
        key="3"
      >
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item
            label={
              <div className="flex items-center justify-between self-stretch">
                <span className="label-text-name flex gap-4 items-center">
                  {t('Length')}
                  {/* <Tooltip title={"Không thể áp dụng tất cả"}>
                    <span className="w-16 h-16 flex">
                      <Icon.ICDeselect />
                    </span>
                  </Tooltip> */}
                </span>
              </div>
            }
            className="self-stretch"
          >
            <InputComponent
              type="number"
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
            />
          </Form.Item>
          <Form.Item label={t('Height')} className="self-stretch">
            <InputComponent
              type="number"
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
            />
          </Form.Item>
          <Form.Item label={t('Column position')} className="self-stretch">
            <div className="flex gap-8 items-center grow">
              <Slider style={{ flex: '1 0 0' }} />
              <InputComponent
                type="number"
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                size={'small'}
                style={{ width: '84px' }}
              />
              <ButtonIconGhostSmall icon={<Icon.ICRestart />} />
            </div>
          </Form.Item>
        </div>
      </Panel>
    ),
  };

  const handleScaleModule = (mdDimensions, mdOptions) => {
    try {
      cabinetEditorContext.setMdCustomData(prevData => {
        const newData = {
          ...prevData,
          mdDimensions: {
            ...prevData.mdDimensions,
            ...mdDimensions,
          },
          mdOptions: {
            ...prevData.mdOptions,
            ...mdOptions,
          },
        };

        const oldDimensions = { ...prevData.mdDimensions };
        const oldOptions = { ...prevData.mdOptions };

        // Scale module với newData
        cabinetEditorContext.clonedModule.scaleModuleWithFormular(
          newData.mdDimensions,
          newData.mdOptions
        );

        //Vẽ lại box
        setTimeout(() => {
          cabinetEditorContext.sceneRef.current.handleDrawBorder();
        }, 0);

        // Scale inside components
        if (cabinetEditorContext.insideLoaderRef?.current) {
          cabinetEditorContext.insideLoaderRef?.current.scaleInsideAfterModuleScale(
            cabinetEditorContext.clonedModule,
            oldDimensions,
            newData.mdDimensions,
            oldOptions,
            newData.mdOptions
          );
        }

        return newData;
      });
    } catch (error) {
      console.error('Error scaling module:', error);
    }
  };

  useEffect(() => {
    if (open)
      form.setFieldsValue({
        width: cabinetEditorContext.mdCustomData.mdDimensions.width * 1000,
        height: cabinetEditorContext.mdCustomData.mdDimensions.height * 1000,
        depth: cabinetEditorContext.mdCustomData.mdDimensions.depth * 1000,
      });
  }, [open]);

  return (
    <LeftMenuDesign
      open={open}
      classNames={{ root: '!left-[72px] relative', content: '!p-0 gap-0' }}
      header={
        <span className="text-title-large text-nowrap">
          {t('Cabinet frame structure')}
        </span>
      }
      content={
        <>
          <div className="left-cabinet-design-menu-header flex px-16 py-8 items-center gap-8 self-stretch flex-col">
            <TabComponent
              items={[
                { key: '1', label: t('Frame') },
                { key: '2', label: t('Column') },
              ]}
              style={{ width: 'fit-content' }}
              defaultActiveKey={tab}
              onChange={value => setTab(value)}
            />
          </div>
          <Form
            form={form}
            labelAlign="left"
            labelWrap
            colon={false}
            layout="vertical"
            validateTrigger={'onChange'}
            className="left-cabinet-design-menu-body flex flex-col items-start overflow-hidden p-8 gap-8 grow self-stretch"
          >
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={['1', '2', '3']}
              onChange={() => {}}
              className="self-stretch overflow-auto"
            >
              {tab === '1' ? (
                <>
                  {formForCurrentCabinet.cabinet}
                  {formForCurrentCabinet.backPlank}
                  {formForCurrentCabinet.cabinetLegs}
                </>
              ) : (
                <>{formColumn.column}</>
              )}
            </Collapse>
          </Form>
        </>
      }
    />
  );
};

export default LeftColumnCabinetCustomDesignMenu;
